import { types } from '../../../types/types';

export const pergrespReducer = (state = {}, action = {}) => {
    let result = {};
    switch (action.type) {
        case types.QUESTIONARIO.PESQUISA_PERGRESP:
            result = action.payload;
            break;    
        default:
            result = state;
            break;
    }
    return result;
}

export const pergCadAtualizaReducer = (state = {}, action = {}) => {
    let result = {};
    switch (action.type) {
        case types.QUESTIONARIO.CADATUALIZAPERG:
            result = action.payload;
            break;    
        default:
            result = state;
            break;
    }
    return result;
}

export const respostasPesquisaReducer = (state = {}, action = {}) => {
    let result = {};
    switch (action.type) {
        case types.QUESTIONARIO.PESQUISA_RESP:
            result = action.payload;
            break;    
        default:
            result = state;
            break;
    }
    return result;
}

export const respCadAtualizaReducer = (state = {}, action = {}) => {
    let result = {};
    switch (action.type) {
        case types.QUESTIONARIO.CADATUALIZARESP:
            result = action.payload;
            break;    
        default:
            result = state;
            break;
    }
    return result;
}